import toaster, { Theme } from '../../../../../../shared/toaster';
import { getIsDemoAccount } from '../../../../../../shared/utils/user-details';

// Shown when a demo account tries to open the Lead Finder extension wizard. The
// extension can't be installed/used on a demo, so we nudge the user to switch.
export const LEAD_FINDER_EXTENSION_DEMO_RESTRICTION_MESSAGE =
  'This is a demo account. To access the Lead Finder extension, please switch to a real account.';

// Guards opening the Lead Finder extension install wizard. In a demo account it
// shows a toaster explaining the restriction and returns false so the caller can
// bail out without opening the modal. Returns true otherwise.
export const ensureLeadFinderExtensionAccess = (): boolean => {
  if (getIsDemoAccount()) {
    toaster.error(LEAD_FINDER_EXTENSION_DEMO_RESTRICTION_MESSAGE, {
      theme: Theme.New,
    });
    return false;
  }
  return true;
};
